<template>
  <div>
    <el-table cell-style="vertical-align:top" :data="displayData" style="width: 100%">
      <el-table-column label="Teacher">
        <template slot-scope="scope">
          <K2Text link="true">{{ scope.row.StaffName }}</K2Text>
          <div>
            <K2Text class="label-control"
              >{{ scope.row.Moments }} Moments | {{ scope.row.Students }}
              Students
            </K2Text>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Student Name list">
        <template slot-scope="scope">
          <K2Text link="true" v-for="item of scope.row.RecentUpdates" :key="item.StudentID">{{ item.StudentName }}<br /></K2Text>
        </template>
      </el-table-column>
      <el-table-column label="Moments" align="center">
        <template slot-scope="scope">
          <K2Text v-for="item of scope.row.RecentUpdates" :key="item.StudentID">{{ item.Moments }}<br /></K2Text>
        </template>
      </el-table-column>
      <el-table-column label="Action">
        <template slot-scope="scope" style="vertical-align: top">
          <K2Button class="mb-2" :styles="{ minWidth: 210 }" size="mini" style="vertical-align: top" @onclick="handleTeacherPost(scope.$index, scope.row)"
            >View All Student Posts
          </K2Button>
          <K2Button size="mini" @onclick="handleTeacherClick(scope.$index, scope.row)">View Individual Student Posts </K2Button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="dataList"
      small
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :total="dataList.length"
      :page-size="pageSize"
      class="mt-4"
    />
  </div>
</template>

<script>
import uiVariable from '../../../config/uiVariable'
import K2Text from '../../../uiComponents/k2Text/k2Text'
import K2Row from '../../../uiComponents/k2Row/k2Row'
import K2Button from '../../../uiComponents/k2Button/k2Button'
// import K2Filter from "../../../uiComponents/k2Filter/k2Filter";

export default {
  name: 'DashboardTable',
  components: { K2Button, K2Row, K2Text },
  props: ['onclick', 'tabList', 'dataList', 'dateRange'],
  data() {
    return {
      uiVariable: uiVariable,
      pageSize: 10,
      page: 1,
      tableData: [
        {
          teacher: 'Teacher A',
          Moments: 100,
          students: 100,
          recentUpdates: [
            {
              student: 'Sophiee Oscar',
              moments: 1,
            },
            {
              student: 'Enzo Tham',
              moments: 2,
            },
            {
              student: 'Chen Le Aimee LIAO',
              moments: 3,
            },
          ],
        },
      ],
    }
  },
  computed: {
    displayData() {
      if (this.dataList && this.dataList.length) {
        this.total = this.dataList.length
        return this.dataList.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)
      }
    },
  },
  watch: {
    dataList: function (value) {
      // watch it
      if (value) {
        this.handleDataList(value)
      }
    },
  },
  async mounted() {
    this.handleDataList()
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val
    },
    handleDataList() {
      if (this.dataList && this.dataList.length) {
        this.dataList.forEach(d => {})
      }
    },
    handleTeacherPost(index, row) {
      console.log(index, row, 'handleTeacherPost')
      this.$router.push({ name: 'ActivityPage', params: { StaffID: row.StaffID, dateRange: this.dateRange } })
    },
    handleTeacherClick(index, row) {
      let studentList = []
      row.RecentUpdates.forEach(item => studentList.push(item.StudentID))
      console.log(studentList)
      this.$router.push({ name: 'DashboardStatePage', params: { Staff: row, studList: studentList.toString(), dateRange: this.dateRange } })
    },
  },
}
</script>
